<template>
  <div>
    <div class="page-header">
      <parallax
        class="page-header-image"
        style="background-image:url('img/ea-01.jpg')"
      >
      </parallax>
      <div class="container">
        <div class="content-center brand">
          <img class="n-logo" src="img/stormhaven-logo.png" alt="" />
          <h1 class="h1-seo">Stormhaven Studios</h1>
          <h3>An independent game studio working on <br />  <a href="https://www.embersadrift.com" class="btn btn-link btn-info" target="_blank"><img src="img/Embers-Logo.png" alt="Embers Adrift" /></a></h3>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Parallax } from '@/components';

export default {
  name: 'index',
  bodyClass: 'index-page',
  components: {
    Parallax
  }
};
</script>
<style></style>
